<template>
  <div>
    <van-nav-bar title="分享海报" left-text="返回" left-arrow @click-left="$router.back()" />

    <div class="poster" v-if="posterUrl">
      <img :src="posterUrl" alt="">
      <div class="description">长按转发给朋友 或 保存到手机后转发图片给朋友</div>
    </div>
    <div class="page-container" v-else ref="PageContainerRef">
      <img class="bg" :src="bgPoster" alt="" @load="onLoadByImg">
      <div class="content" v-if="qrcodeUrl">
        <div class="price">
          <div class="left">面额：</div>
          <div class="right">{{ detail.rebate }}</div>
        </div>
        <div class="title">{{ detail.name }}</div>
        <div class="qrcode">
          <img :src="qrcodeUrl" alt="">
        </div>
        <div class="tips">微信扫一扫或长按识别二维码领取</div>
      </div>
    </div>

    <popup-message ref="PopupMessageRef"></popup-message>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import mixin from './mixin/index'

import { NavBar } from 'vant'
import PopupMessage from './components/PopupMessage.vue'

import bgPoster from './images/bg-poster.js'

export default {
  name: 'EGShare',
  mixins: [mixin],
  components: {
    VanNavBar: NavBar,
    PopupMessage
  },
  data () {
    return {
      bgPoster,
      posterUrl: ''
    }
  },
  computed: {},
  watch: {},
  created () {
    const stopWatch = this.$watch('flag', (val) => {
      // 数据加载完毕、生成二维码 +1 背景图片加载完毕 +1
      if (val === 2) {
        if (this.detail.status === 1) {
          requestAnimationFrame(() => {
            setTimeout(async () => {
              this.posterUrl = await this.getPoster()
            }, 100) // 微调这个延迟值以适配不同设备
          })
        } else {
          this.$refs.PopupMessageRef.open({
            title: '提示',
            message: this.errMsg,
            cancelShow: false
          })
        }
        stopWatch()
      }
    })
  },
  methods: {
    onLoadByImg (e) {
      this.flag += 1
    },
    async getPoster () {
      const PageContainerRef = this.$refs.PageContainerRef

      let posterUrl = ''
      if (!PageContainerRef) {
        console.error('PageContainerRef为空: ')
        return posterUrl
      }
      // 设置配置项，可以在官方文档查
      const options = {
        useCORS: true,
        allowTaint: false,
        scale: window.devicePixelRatio // 放大倍数，消除截图锯齿
        // backgroundColor: null, // 设置背景色，null表示透明。若不设置此项，默认是白色背景.
      }
      try {
        const canvas = await html2canvas(PageContainerRef, options)
        posterUrl = canvas.toDataURL('image/png')
      } catch (err) {
        console.info('制作海报出错了:', err)
      }
      return posterUrl
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
/deep/ .van-nav-bar  {
  .van-nav-bar__text {
    color: #404040;
  }
  .van-icon {
    color: #b2b2b2;
  }
}
.poster {
  width: 100%;
  position: relative;
  .description {
    width: 5.40rem;
    padding: 0.10rem 0.20rem;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 999rem;
    position: absolute;
    bottom: 1.20rem;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 0.22rem;
    color: #ffffff;
    text-align: center;
  }
}
.page-container {
  width: 100%;
  position: relative;

  .content {
    width: 6.68rem;
    height: 8.48rem;
    background: #ffffff;
    margin: 0.70rem 0 0;
    text-align: center;
    position: absolute;
    top: 2.76rem;
    left: 0;
    right: 0;
    margin: auto;

    .price {
      margin-top: 0.60rem;
      .flex-center;
      align-items: flex-end;

      .left {
        margin-bottom: 0.10rem;
        font-size: 0.22rem;
        color: #626262;
      }
      .right {
        font-size: 0.50rem;
        color: #FF4747;
      }
    }
    .title {
      margin-top: 0.20rem;
      font-size: 0.28rem;
      font-weight: bold;
      color: #464646;
    }
    .qrcode {
      margin: 0.60rem auto 0;
      width: 3.22rem;
      height: 3.22rem;
    }
    .tips {
      margin-top: 0.30rem;
      font-size: 0.22rem;
      color: #7F7F7F;
    }
  }
}
</style>
